<cmps-dialog>
    <cmps-dialog-body>
        <div
            class="cmps-cdk-d-flex cmps-cdk-justify-content-center cmps-cdk-text-center"
        >
            <div class="cmps-cdk-flex-30">
                {{ _i18n._9297_YES | translate }}
            </div>
            <div class="cmps-cdk-flex-30 cmps-cdk-mx-0dot25">
                {{ _i18n._9298_NO | translate }}
            </div>
            <div class="cmps-cdk-flex-30">{{ _i18n._842_N_A | translate }}</div>
        </div>
        <div
            class="cmps-cdk-d-flex cmps-cdk-justify-content-center cmps-cdk-mt-0dot25 cmps-cdk-text-center"
        >
            <div
                class="cmps-cdk-flex-30 cmps-cdk-border-width-1p cmps-cdk-border-solid cmps-cdk-border-color-grey-300"
            >
                <cmps-icon
                    class="cmps-cdk-fill-green-100"
                    svgIcon="check-circle"
                ></cmps-icon>
            </div>
            <div
                class="cmps-cdk-flex-30 cmps-cdk-mx-0dot25 cmps-cdk-border-width-1p cmps-cdk-border-solid cmps-cdk-border-color-grey-300"
            >
                <cmps-icon
                    class="cmps-cdk-fill-blue-100"
                    svgIcon="alert-circle"
                ></cmps-icon>
            </div>
            <div
                class="cmps-cdk-flex-30 cmps-cdk-border-width-1p cmps-cdk-border-solid cmps-cdk-border-color-grey-300"
            >
                <cmps-icon
                    class="cmps-cdk-fill-grey-300"
                    svgIcon="cancel"
                ></cmps-icon>
            </div>
        </div>
    </cmps-dialog-body>
</cmps-dialog>
